import { useMutation, useQueryClient } from "react-query";
import authAPI from "../authAPI";

export const useAddGroupMember = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ groupId, userId, roleId, email }) =>
      authAPI.addGroupMember(groupId, userId, roleId, email),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(["groupMembers", variables.groupId]);
        queryClient.invalidateQueries(["group"]);
      },
      onError: (error) => {
        console.error("Error while adding group member:", error);
      },
    }
  );
};
